import { parseQuery } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { selectById as selectCalendarConnectionById, useFetchCalendarAccountsQuery } from 'features/calendar_connections'

export const useIntegrationProviderError = ({ id, provider = null }) => {
  const { search } = useLocation()
  const { error: queryIntegrationError, kind: queryKind } = parseQuery(search)
  const { data } = useFetchCalendarAccountsQuery({}, { skip: !id })
  const { kind, error: accountError, blocked } = useMemo(() => (data && selectCalendarConnectionById(data, id)) || {}, [data, id])

  const accountKind = provider || kind

  const blockedError = blocked ? I18n.t('publisher.calendar.account_disabled_warning') : null

  const queryError = useMemo(() => {
    if (queryKind !== accountKind) return null

    if (queryIntegrationError === 'blocked_by_controlled_domain') {
      return I18n.t('errors.domain_control.calendar_connection_blocked')
    }
    return null
  }, [queryIntegrationError, queryKind, accountKind])

  return {
    accountError,
    blockedError,
    queryError,
    hasError: accountError || blockedError || queryError
  }
}
